/* istanbul ignore file */

import styled from 'styled-components'

export const SortablePackagingItemContainer = styled.div`
  display: grid;
  grid-template-columns: ${props => props.theme.spacing.sp8} 100%;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
  padding-right: ${props => props.theme.spacing.sp32};

  #draggable-icon {
    cursor: ${props => (props.isSortable ? 'grab' : 'default')};
  }

  & > div {
    flex-grow: 1;
  }
`
